
import { ref, useContext, watch, computed } from '@nuxtjs/composition-api'
import usePlaymix from '@/composable/usePlaymix'
import { SELECTION_TEXT_MIX_4, SELECTION_TEXT_MIX_3 } from '@/constants/PlayMix'

export default {
  props: {
    identifier: {
      type: String,
      default: ''
    },
    active: {
      type: Boolean,
      default: false
    },
    bundleId: {
      type: String,
      default: null
    },
    invertedVersion: {
      type: Boolean,
      default: false
    }
  },
  setup (props, { emit }) {
    const { app } = useContext()
    const { getPlayMixServices, selected, selection, data, selectedPlayServices } = usePlaymix(props.identifier, app.$hubble)

    getPlayMixServices(props.bundleId)

    const showServicePicker = ref(props.active)
    const interactionLocked = ref(false)

    const toggle = (bool) => {
      showServicePicker.value = bool
    }

    watch(selected, () => {
      // emit event when all has been choosen
      if (data.value && selected.value.length === data.value.mixVasLimit) {
        // lock interaction during closing flip to avoid racey toggles
        interactionLocked.value = true
        setTimeout(() => { // wait for animation to finish
          const selectedServices = data.value.productOfferingDTOWithContent.filter((_item, i) => selection.value.includes(i))
          selectedPlayServices.value = selectedServices.map(val => val.productOfferingDTO.id)
          emit('success', {
            selectedServices: data.value.productOfferings.filter((_item, i) => selection.value.includes(i))
          })
          // keep locked a bit longer to ensure the flip transition is done
          setTimeout(() => {
            interactionLocked.value = false
          }, 200)
        }, 400)
      } else {
        // allow interaction again when not at limit
        interactionLocked.value = false
        emit('deselected', {
          selectedServices: data.value.productOfferings.filter((_item, i) => selection.value.includes(i))
        })
      }
    })
    const selectionText = computed(() => {
      if (data.value.mixVasLimit === 3) {
        return SELECTION_TEXT_MIX_3
      } else {
        return SELECTION_TEXT_MIX_4
      }
    })
    return {
      selectionText,
      selection,
      data,
      selected,
      showServicePicker,
      toggle,
      interactionLocked
    }
  },
  watch: {
    active: function (newVal) {
      this.showServicePicker = newVal
    }
  }
}
